module.exports = global["Util"] = require("-!/var/www/prod/clients/node_modules/exports-loader/index.js?Util!./util.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?Util!./node_modules/exports-loader?Util!./node_modules/bootstrap/js/dist/util.js-exposed
// module id = 99
// module chunks = 0